import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import { dispatchShowSnack } from '@/store/dispatches';
import { SnackType } from '@/interfaces/snack';
import router from '../router';
export function showErrors(errors) {
  errors.map(function (error) {
    if (error.message) {
      dispatchShowSnack({
        msg: error.message,
        type: SnackType.Error
      });

      if (error.message.statusCode === 401) {
        setTimeout(function () {
          router.replace({
            name: 'SignIn'
          });
        }, 1000);
      }
    }
  });
}
export function showNotification(msg) {
  dispatchShowSnack(msg);
}